import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Handles the Emergent Google OAuth redirect: reads session_id from the URL fragment,
// exchanges it server-side for our own JWT, then routes the user into the app.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { authenticate, setHasWedding } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const claim = localStorage.getItem("pmw_claim") || undefined;
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, claim_token: claim });
        const target = authenticate(data);
        if (localStorage.getItem("pmw_demo") && target === "/paywall") {
          try { await api.post("/demo"); setHasWedding(true); } catch (e) { console.error("demo load failed", e); }
          localStorage.removeItem("pmw_demo");
        }
        localStorage.removeItem("pmw_claim");
        window.history.replaceState({}, "", "/");
        navigate(localStorage.getItem("pmw_demo") ? "/app" : target, { replace: true });
      } catch (e) {
        console.error("Google sign-in failed", e);
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, authenticate, navigate, setHasWedding]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <Heart className="h-8 w-8 text-accent animate-pulse" fill="currentColor" />
      <p className="text-muted-foreground text-sm">Signing you in…</p>
    </div>
  );
}
